import { LazyAction, LazyModule } from 'owa-bundling';
import type * as lazyIndex from './lazyIndex';

export { FILTER_FOLDER_ID_BUILDER } from './types/FilteredFolderFilterProperties';
export type { FilteredFolderFilterProperties } from './types/FilteredFolderFilterProperties';

const lazyModule: LazyModule<typeof lazyIndex> = new LazyModule(
    () => import(/* webpackChunkName: "FrequentlyUsedFolders"*/ './lazyIndex'),
    { name: 'FrequentlyUsedFolders' }
);

export const lazyPrefetchFrequentlyUsedFolders: LazyAction<
    typeof lazyIndex.prefetchFrequentlyUsedFolders,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.prefetchFrequentlyUsedFolders);

export const lazyAddFrequentlyUsedFolder: LazyAction<
    typeof lazyIndex.addFrequentlyUsedFolder,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.addFrequentlyUsedFolder);
